// services/VisitService.js
import AuthService from "./AuthService";

//const VISIT_API_URL = "http://localhost:8081/api/visit/";
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const VISIT_API_URL = `${API_BASE_URL}/api/visit/`;

class VisitService {
  // 🔹 Dohvati sve posete pacijenta po tip tretmana (aurikuloterapija, estetska medicina, body acupuncture)
  async getVisitsByPatientAndTreatmentType(patientId, treatmentTypePath) {
    try {
      const authHeader = AuthService.getAuthHeader();
      console.log("POZIVAM API:", `${VISIT_API_URL}patient/${patientId}/${treatmentTypePath}`);
      console.log("TOKEN:", authHeader);

      const res = await fetch(`${VISIT_API_URL}patient/${patientId}/${treatmentTypePath}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...authHeader,
        },
        credentials: "include",
      });

      console.log("STATUS:", res.status);
      console.log("OK?", res.ok);

      if (!res.ok) {
        const text = await res.text();
        console.error("GREŠKA OD SERVERA:", text);
        throw new Error(`HTTP ${res.status}: ${text}`);
      }

      const data = await res.json();
      console.log("PODACI:", data);
      console.log("DUŽINA:", data.length);
      return data;
    } catch (err) {
      console.error("GREŠKA PRI FETCH-U:", err);
      throw err;
    }
  }

  // 🔹 Dohvati sve posete
  async getAllVisits() {
    try {
      const res = await fetch(VISIT_API_URL, {
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`Greška: ${res.status} - ${text}`);
      }

      return await res.json();
    } catch (err) {
      console.error("Greška pri dohvatu svih poseta:", err);
      throw err;
    }
  }

  // 🔹 Dohvati sve posete jednog pacijenta
  async getAllVisitsByPatientId(patientId) {
    try {
      const authHeader = AuthService.getAuthHeader();
      const res = await fetch(`${VISIT_API_URL}patient/${patientId}`, {
        headers: {
          "Content-Type": "application/json",
          ...authHeader,
        },
        credentials: "include",
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return await res.json();
    } catch (err) {
      console.error("Greška:", err);
      throw err;
    }
  }

  // 🔹 Kreiraj novu posetu
  async createVisit(visitDTO) {
    console.log("ŠALJEM:", JSON.stringify(visitDTO, null, 2));
    try {
      const res = await fetch(VISIT_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
        body: JSON.stringify(visitDTO),
      });

      const text = await res.text();
      console.log("STATUS:", res.status);
      console.log("RESPONSE:", text);

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${text}`);
      }

      try {
        return JSON.parse(text);
      } catch {
        return {}; // ako je prazan odgovor
      }
    } catch (err) {
      console.error("Greška pri kreiranju posete:", err);
      throw err;
    }
  }

  // 🔹 NOVO: update posete
  async updateVisit(id, visitDTO) {
    console.log("Updating visit with ID:", id, visitDTO);

    try {
      const res = await fetch(`${VISIT_API_URL}${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
        body: JSON.stringify(visitDTO),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`HTTP ${res.status}: ${text}`);
      }

      const data = await res.json();
      return data;
    } catch (err) {
      console.error("Greška pri update-u posete:", err);
      throw err;
    }
  }

  // 🔹 Obriši posetu
  async deleteVisit(id) {
    try {
      const res = await fetch(`${VISIT_API_URL}${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          ...AuthService.getAuthHeader(),
        },
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(`HTTP ${res.status}: ${text}`);
      }
    } catch (err) {
      console.error("Greška pri brisanju posete:", err);
      throw err;
    }
  }


  // 🔹 Čekaonica za doktora
async getWaitingList(doctorId) {
  const res = await fetch(`${VISIT_API_URL}doctor/${doctorId}/waiting`, {
    headers: {
      "Content-Type": "application/json",
      ...AuthService.getAuthHeader(),
    },
  });

  if (!res.ok) throw new Error("Greška");
  return await res.json();
}

async getAllWaiting() {
  const res = await fetch(`${VISIT_API_URL}waiting`, {
    headers: {
      "Content-Type": "application/json",
      ...AuthService.getAuthHeader(),
    },
  });

  if (!res.ok) throw new Error("Greška");
  return await res.json();
}

async startVisit(id) {
  const res = await fetch(`${VISIT_API_URL}${id}/start`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...AuthService.getAuthHeader(),
    },
  });

  if (!res.ok) throw new Error("Greška");
}
// 🔹 Završavanje posete (status -> DONE)
async completeVisit(id) {
  try {
    const res = await fetch(`${VISIT_API_URL}${id}/complete`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...AuthService.getAuthHeader(),
      },
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`HTTP ${res.status}: ${text}`);
    }
  } catch (err) {
    console.error("Greška pri završavanju posete:", err);
    throw err;
  }
}


}

export default new VisitService();
